import type { Player } from '../api/types';

export interface DraftMatch {
  _id: number;
  player1: Player;
  player2: Player;
  player1Score?: number;
  player2Score?: number;
  setsNumber?: number;
}

export const isEntered = (match: DraftMatch): boolean =>
  match.setsNumber !== undefined && match.setsNumber > 0;

// CONTEXT.md: every Participant present plays every other Participant once.
export function numberOfMatches(participantCount: number): number {
  if (participantCount < 2) {
    return 0;
  }
  return (participantCount * (participantCount - 1)) / 2;
}

// Four sets, or two when the Participant count is odd. Changed 2016 in commit ff35bf3.
export function setsPerMatch(participantCount: number): number {
  return participantCount % 2 === 0 ? 4 : 2;
}

export function generateMatches(participants: readonly Player[]): DraftMatch[] {
  const remaining = participants.slice().reverse();
  const matches: DraftMatch[] = [];

  for (let i = remaining.length - 1; i >= 1; i--) {
    const current = remaining.splice(i, 1)[0];
    if (current === undefined) {
      continue;
    }
    for (let j = remaining.length - 1; j >= 0; j--) {
      const opponent = remaining[j];
      if (opponent === undefined) {
        continue;
      }
      matches.push({
        player1: current,
        player2: opponent,
        _id: i * 100 + j
      });
    }
  }
  return matches;
}
